import localStorageService from '../../../../../features/shared/services/local-storage/local-storage.service';
import { castTo } from '../../../../../features/shared/utils/cast-to';
import { ThemeEnum } from '../../../../theme/enums/theme.enum';
import { ThemeConfigModel } from '../../models/theme-config.model';
import { themeConfigDef } from './utils/theme-config/theme-config-def.util';

export const useThemeConfig = (): ThemeConfigModel | undefined => {
  const themeName =
    castTo<ThemeEnum>(localStorageService.get('themePalette')) ??
    ThemeEnum.SPARQ;

  return themeConfigDef.get(themeName);
};
